import { EBannerType, TGuideList } from 'shared/types/guide';
import { EOfferType } from 'shared/types/wantType';
import { AESTHETIC_INTERIOR, PLACE_AD } from './links';

export const RENT_GUIDE_LIST: TGuideList[] = [
  {
    step: 1,
    title: 'Подготовьте недвижимость к сдаче в аренду',
    slider: [
      {
        image: '461eb93b-9b4d-4237-8c90-3191311de7aa.png',
        title: 'Какие документы нужно собрать перед тем, как сдавать недвижимость?',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kakie-dokumenty-nuzhno-sobrat-pered-tem-kak-sdavat-kvartiru-332304/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '583a575c-f322-4f94-a349-9f58e9298028.png',
        title: 'Посчитайте расходы при сдаче недвижимости в аренду: ремонт, страховка, налоги и другие',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-poschitajte-rashody-pri-sdache-kvartiry-v-arendu-remont-strahovka-nalogi-i-drugie-328916/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '5895528b-54f0-4103-bb4f-b6f38c082a57.png',
        title: 'С чего начать, если вы хотите сдать недвижимость: взвесьте риски',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-s-chego-nachat-esli-vy-hotite-sdat-kvartiru-vzveste-riski-328913/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'e53c3f91-5a4b-427d-bcd5-f15b1dfde4a1.png',
        title: 'Как подготовить недвижимость к сдаче в аренду',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-podgotovit-kvartiru-k-sdache-v-arendu-328898/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '0898ab30-44f4-4415-8c19-dc9099f061ac.png',
        title: 'Что такое хоумстейджинг и как это работает',
        notice: '15 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-chto-takoe-houmstejdzhing-i-kak-eto-rabotaet-325088/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '55a646d6-ace7-4912-8488-b8c8c85ff6a8.png',
        title: 'Как сдать квартиру с недостатками?',
        notice: '7 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-arenda-kak-sdat-kvartiru-s-nedostatkami-328763/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'd6991827-1c2f-405d-9000-97782b5900b7.png',
        title: 'Как организовать бесконтактное заселение при сдаче недвижимости в аренду',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-organizovat-beskontaktnoe-zaselenie-pri-sdache-kvartiry-v-arendu-330997/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '31d5527c-2190-4863-aff8-396fa26b7ff3.png',
        title: 'Бытовая техника: минимальный набор для недвижимости под сдачу',
        notice: '3 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-bytovaja-tehnika-minimalnyj-nabor-dlja-kvartiry-pod-sdachu-328895/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '67066da0-4d73-4b31-be07-6dcbf39c6673.png',
        title: 'Как создать эстетичный интерьер, чтобы легко продать жилье',
        notice: '9 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-sozdat-estetichnyj-interer-chtoby-obustroit-legko-prodat-ili-sdat-zhile-333555/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
  {
    step: 2,
    title: 'Создайте эффективное объявление',
    slider: [
      {
        image: '96ede963-1773-43a7-add2-f2c005f3dee7.png',
        title: 'Какие факторы влияют на ставку аренды и как ее определить?',
        notice: '3 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kakie-faktory-vlijajut-na-stavku-arendy-i-kak-ee-opredelit-328919/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '9944277b-53f4-4eed-9b94-15abd6995cce.png',
        title: 'Пошаговая инструкция, как разместить объявление на Циан',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-poshagovaja-instruktsija-kak-razmestit-objavlenie-na-tsian-332829/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '0629f676-fc37-4b80-bf40-bb27418e54c5.png',
        title: 'Как привлечь больше внимания к своему объявлению на Циан?',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-privlech-bolshe-vnimanija-k-svoemu-objavleniju-na-tsian-333459/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'be838fb7-5e32-48bf-8d73-b2e47320e5eb.png',
        title: 'Как составить хорошее описание недвижимости для сдачи в аренду?',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-pravilno-pisat-objavlenie-dlja-sdachi-kvartiry-v-arendu-293271/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '97287ff0-75af-4976-9cf7-35f07be73159.png',
        title: 'Как снимать фото и видео для объявления об аренде?',
        notice: '4 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kak-snimat-foto-i-video-dlja-objavlenija-ob-arende-328854/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '4baf9a48-003d-4f7e-8188-0b3226361659.png',
        title: 'Видеоинструкция: как опубликовать объявление на Циан?',
        notice: '7 мин. времени на просмотр',
        type: 'all',
        link: 'https://youtu.be/glbPvTb4hWw?si=3x89Lzk3cYJR9t7i',
      },
      {
        image: '403b4293-ff4c-4da2-af24-713da0b6332c.png',
        title: 'Видеоинструкция: как поднять объявление в поиске?',
        notice: '5 мин. времени на просмотр',
        type: 'all',
        link: 'https://youtu.be/3LPyyoLKdyo?si=Ix3Pdv-w8kg-jfBY',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Blue,
        title: 'Размещайтесь на Циан',
        linkBtn: { url: PLACE_AD, text: 'Разместить объявление' },
        imageClass: 'cian-pin',
      },
    },
  },
  {
    step: 3,
    title: 'Общайтесь с потенциальными арендаторами',
    slider: [
      {
        image: '9211af1e-9456-4f34-aade-979c16ecfce1.png',
        title: 'Пять правил, как общаться с потенциальным арендатором по телефону и в чатах',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-pjat-pravil-kak-obschatsja-s-potentsialnym-arendatorom-po-telefonu-i-v-chatah-328907/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '976101d9-9cd3-4df5-857a-beac77bb28ae.png',
        title: 'Как оценить надежность арендатора?',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-proverka-arendatora-kak-sobstvenniku-otsenit-ego-nadezhnost-332391/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'c8a5e3ed-8ad4-4446-83fb-e56713f24067.png',
        title: 'Какие моменты нужно обсудить с арендатором до заключения договора?',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kakie-momenty-nado-obsudit-s-arendatorom-do-zakljuchenija-dogovora-328922/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
  {
    step: 4,
    title: 'Как заключить договор',
    slider: [
      {
        image: '9d366fb6-0bd0-4790-bf9a-8ab0467736da.png',
        title: 'Как проверить потенциального арендатора и его документы?',
        notice: '2 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-proverit-potentsialnogo-arendatora-i-ego-dokumenty-328900/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'cd6ac07d-a6de-43c8-9cb2-c2cd5122e317.png',
        title: 'Как правильно договариваться о задатке?',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-oformit-dogovor-zadatka-pri-sdache-zhilja-v-arendu-334357/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'cff34e4a-835b-48ff-9838-b48073178c6b.png',
        title: 'Как юридически подготовиться к сдаче недвижимости в аренду',
        notice: '0 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-podgotovit-kvartiru-k-sdache-v-arendu-334376/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'd0ca002b-989b-4a4e-bbb0-aefd2af245fa.png',
        title: 'Аренда: кто платит за мелкий ремонт и как возмещать ущерб',
        notice: '4 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-arenda-kto-platit-za-melkij-remont-i-kak-vozmeschat-uscherb-328903/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '0e814de6-8c67-49d6-86b0-93a2b51cc550.png',
        title: 'Как налоговая узнает о сдаче недвижимости в аренду и что за это будет',
        notice: '9 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-nalogovaja-uznaet-o-sdache-kvartiry-v-arendu-i-chto-za-eto-budet-330021/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'b2909bd0-b964-4a98-9bb8-19c8bbc282f5.png',
        title: 'Аренда загородного дома: что обсудить с арендатором при подготовке договора',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://spb.cian.ru/stati-arenda-zagorodnogo-doma-chto-obsudit-s-arendatorom-pri-podgotovke-dogovora-332745/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '1655945e-815f-4582-ade2-622f4b4e5add.png',
        title: 'Собственник или арендатор: кто должен делать мелкий ремонт при аренде дома?',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-sobstvennik-ili-arendator-kto-dolzhen-delat-melkij-remont-pri-arende-doma-332666/?cian_source=guide&cian_medium=rent',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Colored,
        title: 'Как создать эстетичный интерьер, чтобы легко продать или сдать свою недвижимость',
        linkBtn: {
          text: 'Узнать больше',
          url: AESTHETIC_INTERIOR,
        },
        imageClass: 'house',
      },
    },
  },
];
